import { render, staticRenderFns } from "./CardsDinamic.vue?vue&type=template&id=688da866&scoped=true"
import script from "./CardsDinamic.vue?vue&type=script&lang=js"
export * from "./CardsDinamic.vue?vue&type=script&lang=js"
import style0 from "./CardsDinamic.vue?vue&type=style&index=0&id=688da866&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688da866",
  null
  
)

export default component.exports